<app-loader *ngIf="isDisabled"></app-loader>
<form name="LetterForm" (ngSubmit)="Validate(LetterForm)" #LetterForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Letter Document Type</label>
        </div>
        <div class="card-body">
            <div class="row py-1">
                <div class="col-md-12">
                    <label for="LetterDocumentTypeCode">Code <span *ngIf="ID > 0"> :
                            {{LetterDocumentDetail.LetterDocumentTypeCode}} </span> </label>
                    <input *ngIf="ID == 0" type="text" [maxLength]="5" class="form-control"
                        name="LetterDocumentTypeCode" placeholder="Code"
                        [(ngModel)]="LetterDocumentDetail.LetterDocumentTypeCode" (input)="common.ToUpperCaseE($event)"
                        pattern="[a-zA-Z ]*" (keypress)="common.AlphabetOnly($event,true)"
                        #LetterDocumentTypeCode="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter Letter Type Code!
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-12">
                    <label for="LetterDocumentTypeName">Name</label>
                    <input type="text" [maxLength]="50" class="form-control" name="LetterDocumentTypeName"
                        placeholder="Name" [(ngModel)]="LetterDocumentDetail.LetterDocumentTypeName"
                        #LetterDocumentTypeName="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter Letter Type Name!
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-12">
                    <label for="LetterIssuanceLimit">Letter Issuance Limit</label>
                    <input type="text" minlength="1" maxlength="3" class="form-control" name="LetterIssuanceLimit"
                        placeholder="Limit" [(ngModel)]="LetterDocumentDetail.LetterIssuanceLimit"
                        #LetterIssuanceLimit="ngModel" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                        required>
                    <div class="invalid-feedback">
                        Please enter letter issuance limit!
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-12">
                    <label for="ESS_LetterModuleTypeId">For Employee</label>
                    <ng-select name="site" [items]="EmployeeStatus" bindLabel="ESS_LetterModuleTypeName"
                        bindValue="ESS_LetterModuleTypeId" [(ngModel)]="LetterDocumentDetail.ESS_LetterModuleTypeId"
                        placeholder="Select For Employee" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select for employee!
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-12">
                    <label class="Label">
                        Include In Salary rate Contract :
                        <input type="checkbox" name="IncludeInSalaryRateContract"
                            [(ngModel)]="LetterDocumentDetail.IncludeInSalaryRateContract" ngbCheckbox />
                    </label>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-12">
                    <label class="Label">
                        Acknowledgement :
                        <input type="checkbox" name="EMPAcknowledgement"
                            [(ngModel)]="LetterDocumentDetail.EMPAcknowledgement" ngbCheckbox
                            [disabled]="this.LetterDocumentDetail.ESS_LetterModuleTypeId == 3" />
                    </label>
                </div>
            </div>
            <div class="row py-1">
                <div class="col">
                    <label class="Label">
                        Include ESignin :
                        <input type="checkbox" name="IncludeESignIn" [(ngModel)]="LetterDocumentDetail.IncludeESignIn"
                            ngbCheckbox [disabled]="!this.common.CompanyParameterValue.IsESignInAllowed"
                            [disabled]="this.LetterDocumentDetail.ESS_LetterModuleTypeId == 3" />
                    </label>
                </div>
                <div class="col-auto" *ngIf="!this.common.CompanyParameterValue.IsESignInAllowed">
                    <span class="badge warning">Esign not activated</span>
                </div>
                <div class="col-auto" *ngIf="this.common.CompanyParameterValue.IsESignInAllowed">
                    <span class="badge view">Maximum Cordinate X-430 | Y-800 </span>
                </div>
            </div>
            <div class="row py-1 ps-5">
                <div class="col-md-12">
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='firstpageonly' name="AddESignInOn"
                                [(ngModel)]="LetterDocumentDetail.AddESignInOn" [ngModelOptions]="{standalone: true}"
                                [disabled]="!LetterDocumentDetail.IncludeESignIn">
                            First Page Only
                        </label>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='lastpageonly' name="AddESignInOn"
                                [(ngModel)]="LetterDocumentDetail.AddESignInOn" [ngModelOptions]="{standalone: true}"
                                [disabled]="!LetterDocumentDetail.IncludeESignIn">
                            Last Page Only
                        </label>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='allpage' name="AddESignInOn"
                                [(ngModel)]="LetterDocumentDetail.AddESignInOn" [ngModelOptions]="{standalone: true}"
                                [disabled]="!LetterDocumentDetail.IncludeESignIn">
                            All Page
                        </label>
                    </div>
                </div>
            </div>
            <div class="row py-1 ps-5">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-auto"><label for="Xcoordinate">Coordinates</label></div>
                        <div class="col-md-4">
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="Xcoordinate">X</span>
                                <input type="text" minlength="1" maxlength="3" class="form-control" name="Xcoordinate"
                                    placeholder="X" [(ngModel)]="LetterDocumentDetail.Xcoordinate"
                                    #Xcoordinate="ngModel" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                    [disabled]="!LetterDocumentDetail.IncludeESignIn" required>
                                <div class="invalid-feedback">
                                    Please enter X coordinate!
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="Ycoordinate">Y</span>
                                <input type="text" minlength="1" maxlength="3" class="form-control" name="Ycoordinate"
                                    placeholder="Y" [(ngModel)]="LetterDocumentDetail.Ycoordinate"
                                    #Ycoordinate="ngModel" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                    [disabled]="!LetterDocumentDetail.IncludeESignIn" required>
                                <div class="invalid-feedback">
                                    Please enter Y coordinate!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.common.CompanyParameterValue.IsESignInAllowed">
                <span style="font-size: small;text-align: -webkit-right;color: gray;">Ex. Bottom Left : X-430 | Y-0
                </span>
                <span style="font-size: small;text-align: -webkit-right;color: gray;">Ex. Bottom Right : X-0 | Y-0
                </span>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="LetterDocumentDetail.Active"
                            [name]="'Active'" id="LetterDocumentDetail">
                        <label class="form-check-label" for="LetterDocumentDetail">
                            Active
                        </label>
                    </div>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                        *ngIf="((this.LetterDocumentDetail.ESS_LetterDocumentTypeMasterID == 0 && this.common.PageRight.IsAdd) || (this.LetterDocumentDetail.ESS_LetterDocumentTypeMasterID > 0 && this.common.PageRight.IsEdit))"><i
                            class="bi bi-save2" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>